import React, { useEffect, useState } from "react";
import { storeChatSessionFeedback } from "../../../services/api/ChatService";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import BaseButton from "@/components/Buttons/BaseButton";
import { toast } from "react-hot-toast";

function FeedbackDialag({ text, onSendFeedback }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>
        <button className="bg-primary text-white rounded px-2 text-xs">
          {text}
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-md">Leave a comment</DialogTitle>
          <DialogDescription>
            <div className="mt-4">
              <Textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
              <div className="mt-2 flex justify-end">
                <BaseButton
                  value={"Send Feedback"}
                  onClick={() => {
                    onSendFeedback(reason);
                    setReason("");
                    setOpen(false);
                  }}
                />
              </div>
            </div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

function AskUserIfChatIsHelpful({
  sessionuuid,
  feedbackGivenProp,
  onFeedbackGivenChange,
}) {
  const [feedbackGiven, setFeedbackGiven] = useState(feedbackGivenProp || null);

  useEffect(() => {
    setFeedbackGiven(feedbackGivenProp || null);
  }, [feedbackGivenProp]);

  return (
    <>
      <div className="flex gap-2 text-xs">
        <p>Did Chatto help you solve your task?</p>
        <>
          <FeedbackDialag
            text="Yes"
            onSendFeedback={async (comment) => {
              const payload = {
                general_feedback: true,
                comment: comment,
              };
              try {
                await storeChatSessionFeedback(sessionuuid, payload);
                console.log("Detailed feedback stored successfully");
                setFeedbackGiven(false);
                toast.success("Thank you for your feedback!");
                onFeedbackGivenChange();
              } catch (error) {
                console.error("Error storing detailed feedback:", error);
              }
            }}
          />
          <FeedbackDialag
            text="No"
            onSendFeedback={async (comment) => {
              const payload = {
                general_feedback: false,
                comment: comment,
              };
              try {
                await storeChatSessionFeedback(sessionuuid, payload);
                console.log("Detailed feedback stored successfully");
                setFeedbackGiven(false);
                toast.success("Thank you for your feedback!");
              } catch (error) {
                console.error("Error storing detailed feedback:", error);
              }
            }}
          />
        </>
      </div>
    </>
  );
}

export default AskUserIfChatIsHelpful;
